import { Stack, Text } from '@mantine/core';
import { AfaLoader, AfaLoaderSize } from '../AfaLoader';

export interface AfaPageLoaderProps {
  /**
   * Mensaje principal a mostrar
   * @default "Carregant..."
   */
  message?: string;
  /**
   * Mensaje secundario opcional (más pequeño y atenuado)
   * @default "Si us plau, espera un moment"
   */
  description?: string;
  /**
   * Tamaño del loader
   * @default "xl"
   */
  size?: AfaLoaderSize;
  /**
   * Altura del contenedor
   * @default "60vh"
   */
  height?: string | number;
}

/**
 * AfaPageLoader - Loader para páginas completas
 * 
 * Uso típico para carga inicial de páginas:
 * ```tsx
 * if (isLoading) {
 *   return <AfaPageLoader message="Cargando dashboard..." />;
 * }
 * ```
 * 
 * Ejemplos:
 * ```tsx
 * // Básico
 * <AfaPageLoader />
 * 
 * // Personalizado
 * <AfaPageLoader 
 *   message="Cargando datos del usuario..." 
 *   description="Esto puede tardar unos segundos"
 *   size="xl"
 * />
 * ```
 */
export function AfaPageLoader({ 
  message = "Carregant...", 
  description = "Si us plau, espera un moment",
  size = "xl",
  height = "60vh" 
}: AfaPageLoaderProps) {
  return (
    <Stack align="center" justify="center" h={height}>
      <AfaLoader size={size} />
      <Text size="lg" fw={500}>{message}</Text>
      {description && (
        <Text size="sm" c="dimmed">{description}</Text>
      )}
    </Stack>
  );
}